import React from 'react'

import './radio-button.scss'

const RadioButton = ({ label, checked = false, onChange }) => (
  <label className={`radio ${checked && 'checked'}`}>
    <input type="radio" checked={checked} onChange={onChange} />

    <div className="label">{label}</div>
  </label>
)

export default RadioButton
